import { unwrapResult } from '@reduxjs/toolkit';
import { findCurrency, validate } from 'multicoin-address-validator';
import { call, put } from 'redux-saga/effects';

import { callAsyncRequest, putRequest } from '@sagas/helpers';

import { withdrawActions } from '@modules';
import { AddressType } from '@modules/withdraw/types';

import { CheckValidateAddressType } from './types';

enum NetworkTypes {
  local = 'both',
  test = 'both',
  prod = 'prod',
}

export function* setValidation(data: AddressType) {
  const { isValid, address, currency, domain } = data;
  yield put(withdrawActions.setAddressValidation({ isValid, address, currency, domain }));
}

export function* validateAddress(data: CheckValidateAddressType) {
  const { currency, address, network, domain } = data;

  const callValidateAddress = yield* callAsyncRequest(withdrawActions.validateAddress, {
    address,
    currency,
    network,
  });
  const response = yield* putRequest(callValidateAddress);

  const isValid: boolean = yield response
    .then(unwrapResult)
    .then(res => res?.data?.isValid)
    .catch(() => false);
  const params = { isValid, currency, address, domain };
  yield call(setValidation, params);
}

export function* getAddressValidation(data: CheckValidateAddressType) {
  const { address = '', currency, domain } = data;

  if (currency) {
    if (!CONST.validateAddressIgnoreCurrencies.includes(currency) && findCurrency(currency)) {
      const isValidate = validate(address, currency, NetworkTypes[CONST.env]);
      if (isValidate) yield call(validateAddress, data);
    } else {
      yield call(validateAddress, data);
    }
  } else {
    const params: AddressType = { isValid: false, currency, address, domain };
    yield call(setValidation, params);
  }
}
